<template>
    <div class="panel panel-info">
        <div class="panel-heading"><h4 class="panel-title"><i class="fa fa-book"></i>添加试卷</h4></div>
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal">
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"> <span class="required">*</span>试卷名称</label>
                                <div class="col-sm-9">
                                    <input type="text" name="sjmc" v-model="model.sjmc"
                                           v-validate="{required:true,max:100}" class="form-control" data-vv-as="试卷名称"
                                           placeholder=""/>
                                    <span class="error_validate_msg"><em>{{ errors.first('sjmc') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>试卷状态</label>
                                <div class="col-sm-9">
                                    <select name="sjzt" v-model="model.sjzt" class="form-control"
                                            v-validate="{required:true}" data-vv-as="试卷状态">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in sjztList" :key="item.value" :value="item.value">
                                            {{item.text}}
                                        </option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('sjzt') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--培训项目-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"> <span class="required">*</span>报考专业</label>
                                <div class="col-sm-9">
                                    <select name="pcId" v-model="model.pcId" class="form-control"
                                            v-validate="{required:true}" data-vv-as="报考专业">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in pcList" :key="item.id" :value="item.id">{{item.mc}}
                                        </option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('pcId') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>课程</label>
                                <div class="col-sm-9">
                                    <select name="kcId" v-model="model.kcId" class="form-control"
                                            v-validate="{required:true}" data-vv-as="课程">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in kcList" :key="item.id" :value="item.id">
                                            {{item.kcdm}}-{{item.kcmc}}
                                        </option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('kcId') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--开考时间-->
                    <div class="col-sm-12" style="margin-top: 6px">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>开始时间</label>
                                <div class="col-sm-9">
									<DateTimePicker v-model="model.kksj" name="kksj" v-validate="{required:true}" data-vv-as="开始时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                                    <div>
                                        <span class="error_validate_msg"><em>{{ errors.first('kksj') }}</em></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>结束时间</label>
                                <div class="col-sm-9">
									<DateTimePicker v-model="model.jssj" name="jssj" v-validate="{required:true}" data-vv-as="结束时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                                    <div>
                                        <span class="error_validate_msg"><em>{{ errors.first('jssj') }}</em></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" style="margin-top: 6px">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>成绩公布时间</label>
                                <div class="col-sm-9">
									<DateTimePicker v-model="model.cjgbsj" name="cjgbsj" v-validate="{required:true}" data-vv-as="成绩公布时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                                    <div>
                                        <span class="error_validate_msg"><em>{{ errors.first('cjgbsj') }}</em></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>考试时长(分钟)</label>
                                <div class="col-sm-9">
                                    <div>
                                        <input type="text" name="kssc" v-model="model.kssc"
                                               v-validate="{required:true,max:100}" class="form-control"
                                               data-vv-as="考试时长" placeholder=""/>
                                        <span class="error_validate_msg"><em>{{ errors.first('kssc') }}</em></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--显示形式-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"> <span class="required">*</span>显示形式</label>
                                <div class="col-sm-9">
                                    <select name="sjxslx" v-model="model.sjxslx" class="form-control"
                                            v-validate="{required:true}" data-vv-as="显示形式">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in sjxslxList" :key="item.value" :value="item.value">
                                            {{item.text}}
                                        </option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('sjxslx') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"> <span class="required">*</span>是否显示答案</label>
                                <div class="col-sm-9">
                                    <select name="sfxsda" v-model="model.sfxsda" class="form-control"
                                            v-validate="{required:true}" data-vv-as="显示形式">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in sfxsdaList" :key="item.value" :value="item.value">
                                            {{item.text}}
                                        </option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('sfxsda') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--试卷类型-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"> <span class="required">*</span>试卷类型</label>
                                <div class="col-sm-9">
                                    <select name="sjlx" v-model="model.sjlx" class="form-control"
                                            v-validate="{required:true}" data-vv-as="试卷类型">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in sjlxList" :key="item.value" :value="item.value">
                                            {{item.text}}
                                        </option>
                                    </select>
									<span v-if=" model.sjlx==='PT' " :style="[sjlxStyle]">考生试卷相同</span>
									<span v-if=" model.sjlx==='SJ' " :style="[sjlxStyle]">各考生试卷随机生成</span>
									<span v-if=" model.sjlx==='MB' " :style="[sjlxStyle]">根据试卷模板智能组卷</span>
                                    <span class="error_validate_msg"><em>{{ errors.first('sjlx') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>试题排列顺序</label>
                                <div class="col-sm-9">
                                    <select name="stplsx" v-model="model.stplsx" class="form-control"
                                            v-validate="{required:true}" data-vv-as="试题排列顺序">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in stplsxList" :key="item.value" :value="item.value">
                                            {{item.text}}
                                        </option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('stplsx') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--试卷说明-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label">试卷说明</label>
                                <div class="col-sm-9">
                                    <textarea class="form-control" v-model="model.sjsm" rows="5"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--按钮-->
                    <div class="col-sm-12 text-center" style="margin-top: 30px">
                        <div class="form-group">
                            <button @click="save()" type="button" class="btn btn-primary btn-sm "
                                    style="margin-right:3px"><i class="" aria-hidden="true"></i>提交
                            </button>
                            <button @click="fh()" type="button" class="btn btn-primary btn-sm "
                                    style="margin-right:3px"><i class="" aria-hidden="true"></i>取消
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

    /**
     * 平时作业/创建试卷 -新增
     */
    export default {
        name: "ExamPaperAdd",
        components: {
        },
        data: function () {
            return {
                sjlxStyle: {
                    color: 'red'
                },
                kcList: [],  //课程list
                pcList: [],//培训项目list
                sjflList: [],
                sjztList: [],
                sfxsdaList: [],
                sjxslxList: [],
                sjlxList: [],
                stplsxList: [],
                model: {
                    sjmc: '', //试卷名称
                    pcId: '', //培训项目
                    kcId: '', //课程
                    sjzt: '',//试卷状态
                    kksj: '', //开考时间
                    jssj: '', //结束时间
                    sfxsda: '1',//是否显示答案
                    sjxslx: 'ZJZS',//试卷显示类型
                    sjlx: 'PT',//试卷类型
                    stplsx: 'ZC',//试卷排列顺序
                    sjsm: '',//试卷说明
                    cjgbsj: '', //成绩公布时间
                    kssc: ''
                }
            }
        },
        created: function () {
            this.$store.commit('setBreadcrumb', [ {name: '自学考试'}, {name: '试卷管理'}, {name: '综合测验创建试卷'}]);
            this.$store.commit('setShowReturnBackBtn',true);
            this.sjflList = [{value: 'PSZY', text: '平时作业'}, {value: 'ZHCY', text: '综合测验'}];//试卷分类
            this.sjztList = [{value: 'ZCKY', text: '正常可用'}, {value: 'BKY', text: '不可用'}];//试卷状态
            this.sfxsdaList = [{value: '1', text: '是'}, {value: '0', text: '否'}];//是否显示答案
            this.sjxslxList = [{value: 'ZJZS', text: '整卷展示'}/*, {value: 'DTZS', text: '单题展示'}*/];//试卷显示类型
            this.sjlxList = [{value: 'PT', text: '普通'}, {value: 'SJ', text: '随机'}, {value: 'MB', text: '试卷模板'}];//试卷类型
            this.stplsxList = [{value: 'ZC', text: '正常'}, {value: 'SJ', text: '随机'}];//试题排列顺序
            this.getpcList();

        },
        watch: {  //课程列表联动
            "model.pcId": function (value) {
                if (value) {
                    this.$http.post("/htgl/biz/zypx/sj/zhcy/hqkc", {pcId: value}).then(res => {
                        this.kcList = res.data;
                    });
                }
                else {
                    this.kcList = [];
                }
            }
        },
        methods: {
            //培训项目列表
            getpcList: function () {
                this.$http.post('/htgl/biz/zypx/sj/zhcy/hqpc').then(res => {
                    this.pcList = res.data;
                });
            },
            //返回
            fh: function () {
                this.$router.push({name: 'ExamPaperList'});
            },
            save: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        //成绩公布时间不能早于结束时间!
                        if (new Date(this.model.cjgbsj).getTime() < new Date(this.model.jssj).getTime()) {
                            this.$error('成绩公布时间不能早于结束时间!');
                        }else{
                            this.$http.post('/htgl/biz/zypx/sj/zhcy/xz', this.model).then(res => {
                                if (res.data) {
                                    this.$success("创建试卷成功", () => {
                                        this.$router.push({name: 'ExamPaperList'})
                                    });
                                }
                            })
                        }
                    }
                })
            },
        }

    }
</script>
<style scoped>

</style>
